<template>
  <div class="e-calendar-range">
    <calendar-range-picker
      :formValidator="formValidator"
      :tabView="tabView"
      :model="model"
      :name="fromName"
      :format="format"
      :value-format="valueFormat"
      :disabled="disabled"
      :required="required"
      :type="type"
      @change="onChange()"
      :placeholder="fromPlaceholder">
    </calendar-range-picker>
    <div class="separator">{{separator}}</div>
    <calendar-range-picker
      :formValidator="formValidator"
      :tabView="tabView"
      :model="model"
      :name="toName"
      :format="format"
      :value-format="valueFormat"
      :disabled="disabled"
      :required="required"
      :type="type"
      @change="onChange()"
      :placeholder="toPlaceholder">
    </calendar-range-picker>
  </div>
</template>

<script>
  import {CALENDAR} from '../../config/config'
  import CalendarRangePicker from "./calendar-range-picker";

  export default {
    name: 'e-calendar-range',
    components: {CalendarRangePicker},
    data () {
      return {
        error: null
      }
    },
    props: {
      valueFormat: {
        type: String,
        default: `${CALENDAR.valueFormat} HH:mm:ss`
      },
      format: {
        type: String,
        default: `${CALENDAR.format} HH:mm:ss`
      },
      type: {
        type: String,
        default: 'datetime'
      },
      model: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        default: 'from'
      },
      toName: {
        type: String,
        default: 'to'
      },
      separator: {
        type: String,
        default: ' - '
      },
      disabled: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      tabView: {
        type: String,
        default: null
      },
      modalVariableName: {
        type: String,
        default: null
      },
      formValidator: null,
      placeholder: {
        type: String,
        default: 'от дд.мм.гггг чч:мм:cc'
      },
      toPlaceholder: {
        type: String,
        default: 'до дд.мм.гггг чч:мм:cc'
      }
    },
    computed: {
      fromName () {
        return this.name
      },
      fromPlaceholder () {
        return this.placeholder
      }
    },
    methods: {
      onChange () {
        this.revertRangeIfNeedIt()
        if (this.model[this.fromName] && this.model[this.toName]) {
          this.$emit('changeRange')
        }
      },
      revertRangeIfNeedIt () {
        let wrongRange = false
        if (this.model[this.fromName] && this.model[this.toName]) {
          let valueFormat = this.valueFormat.toString().toUpperCase()
          let valueFormatLen = valueFormat.length
          let fromVal = this.model[this.fromName]
          let to = this.model[this.toName]
          if (typeof to === 'number' && typeof fromVal === "number") {
            console.log('revertRange?', to, fromVal)
            if (fromVal > to) {
              wrongRange = true
            }
          } else {
            // if format = YYYY-MM-DD
            // but value = 2019-04-26 00:00
            if (to.length > valueFormatLen) {
              to = to.substr(0, valueFormatLen)
            }
            if (fromVal.length > valueFormatLen) {
              fromVal = fromVal.substr(0, valueFormatLen)
            }
            let fromUnix = this.$options.filters.dateToUnixTime(
              to.toString(),
              valueFormat.toString()
            )
            let toUnix = this.$options.filters.dateToUnixTime(
              fromVal.toString(),
              valueFormat.toString()
            )
            console.log('revertRange?', fromUnix, toUnix, to, fromVal)
            if (+fromUnix < +toUnix) {
              wrongRange = true
            }
          }
        }
        console.log('wrongRange', wrongRange)
        if (wrongRange === true) {
          let tmp = this.model[this.toName]
          this.model[this.toName] = this.model[this.fromName]
          this.model[this.fromName] = tmp
        }
        return wrongRange
      }
    }
  }
</script>
